import $ from 'jquery';

(function () {

  const $container = $('.content-contact');
  const $interferer = $container.find('.content-interferer');
  const $panel = $container.find('.content-contact__panel');

  const exports = {

    adjustHeight: function() {
      if ($interferer.length === 1) {
        const interfererHeight = $interferer.outerHeight();
        const offset = interfererHeight + 40;
        $panel.css({
          'padding-bottom': offset
        });
        $interferer.css({
          'margin-top': - offset
        });
      }
    }

  };

  $(window).on('resize', function() {
    exports.adjustHeight();
  });
  exports.adjustHeight();

})();
